import { getApiEndpoint } from 'helpers/helpers';
import { useEffect, useState } from 'react';

import { WallPost } from '../types/types';

const feedRequests = new Map<string, Promise<WallPost[]>>();

function fetchFeed(cacheKey: string, url: string) {
  const cachedRequest = feedRequests.get(cacheKey);

  if (cachedRequest) {
    return cachedRequest;
  }

  const request = fetch(url)
    .then((res) => res.json())
    .catch((error) => {
      feedRequests.delete(cacheKey);
      throw error;
    });

  feedRequests.set(cacheKey, request);

  return request;
}

export function useFetchFeed(isUnlimitedFeed: boolean) {
  const [{ items, isLoading }, setState] = useState<{
    items: WallPost[];
    isLoading: boolean;
  }>({
    items: [],
    isLoading: true,
  });

  useEffect(() => {
    const apiEndpoint = getApiEndpoint();
    const feedRequestKey = isUnlimitedFeed ? 'unlimited' : 'default';
    const feedUrl = isUnlimitedFeed
      ? `${apiEndpoint}/getFeed?count=50`
      : `${apiEndpoint}/getFeed`;
    let isUnmounted = false;

    fetchFeed(feedRequestKey, feedUrl)
      .then((feed) => {
        if (isUnmounted) {
          return;
        }

        setState({ items: feed, isLoading: false });
      })
      .catch(() => {
        if (isUnmounted) {
          return;
        }

        setState({ items: [], isLoading: false });
      });

    return () => {
      isUnmounted = true;
    };
  }, [isUnlimitedFeed]);

  return { items, isLoading };
}
